import { pxToRem } from './biomeTokens';

export const bordersTheme = {
  '1px': `${pxToRem(1)} solid`,
  '2px': `${pxToRem(2)} solid`,
  '3px': `${pxToRem(3)} solid`,
  '8px': `${pxToRem(8)} solid`
};
